import './home.scss';
import { Link } from '@reach/router';
import * as React from 'react';
import { FeaturedBlogPosts } from '../../components/blog/featuredBlogPosts';
import { Accreditations } from '../../components/index/accreditations';
import { Awards } from '../../components/index/awards';
import { LogoContainer } from '../../components/index/logoContainer';
import { ParallaxHero } from '../../components/index/parallaxHero';
import { QueensAward } from '../../components/index/queensAward';
import { Typer } from '../../components/index/typer';
import FullScreenSection, { FullScreenSectionCopy } from '../../components/layout/fullScreenSection';
import PageHero from '../../components/layout/pageHero';
import { RMButton } from '../../components/layout/rmButton';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { SplitPane } from '../../components/layout/splitPane';
import { SplitPaneCopy } from '../../components/layout/splitPaneCopy';
import { View } from '../../components/layout/view';
import { FeaturedProjects } from '../../components/project/featuredProjects';
import useIndex from '../../hooks/staticQueries/home/useIndex';
import { RoutePaths } from '../../routes';
import { AnalyticsService } from '../../utils/analytics';
export const Index = () => {
    const { page } = useIndex();
    return (<View className="home">
      <PageHero parallax={false} darkenBg={false}>
        <FullScreenSection darkenBg={false} foreground={<SplitPane left={<FullScreenSectionCopy>
                  <Typer prefix="We " messages={page.header_options} characterDelay={50} characterDeleteDelay={25}/>

                  <div className="hero-copy">
                    <p>{page.subtitle}</p>
                  </div>

                  <QueensAward />

                  <div className="buttons">
                    <Link to={RoutePaths.projects.projects()} onClick={() => AnalyticsService.track('homeCTAClicked', { to: 'projects' })}>
                      <RMButton variant="brand">Projects</RMButton>
                    </Link>

                    <Link to={RoutePaths.contact.contact()} onClick={() => AnalyticsService.track('homeCTAClicked', { to: 'contacts' })}>
                      <RMButton variant="lighten-bg">Get in Touch</RMButton>
                    </Link>
                  </div>
                </FullScreenSectionCopy>} right={<div className="parallax-section">
                  <ParallaxHero />
                </div>}/>}/>
      </PageHero>

      <FeaturedProjects />

      <LogoContainer />

      {page.home_top_copy &&
        page.home_top_copy.map((copy, i) => (<SplitPaneCopy markdown={copy.markdown} image={copy.image[0] && {
            ticket: copy.image[0].ticket,
            alt: 'home image',
        }} video={copy.vimeo_video && {
            posterUrl: copy.vimeo_poster,
            url: copy.vimeo_video,
        }} key={i} button={{
            to: copy.cta_url,
            children: copy.cta_text,
            variant: i % 2 === 0 ? 'brand-tertiary' : 'brand-secondary',
        }}/>))}

      <Awards />

      <FeaturedBlogPosts />

      <SplitPaneCopy floatingImage className="join-us" h3={page.join_us_copy.header} p={page.join_us_copy.copy} image={{
        alt: 'join us',
        ticket: page.join_us_copy.image[0].ticket,
    }} button={{
        to: '/join',
        children: 'Apply Now',
        variant: 'brand-secondary',
    }}/>

      <Accreditations />

      <Footer />

      <BackToTop />
    </View>);
};
export default Index;
